<ccl-base-drawer
    [title]="getDrawer().title"
    [navLinks]="getDrawer().navLinks"
    [saveMessage]="getDrawer().saveMessage"
    [saveLabel]="getDrawer().saveLabel"
    [cancelLabel]="getDrawer().cancelLabel"
    [doneLabel]="getDrawer().doneLabel"
>
    <div class="c-drawer__section"><router-outlet></router-outlet></div>
</ccl-base-drawer>
